import React, { Component, Fragment } from "react";
import Tabs from "react-responsive-tabs";
import PageTitle from "../../Layout/AppMain/PageTitle";
import PicaCSVzTab1 from "./tabs/PicaC&SVzTab1";

export default class PicaCSVzDashboard extends Component {
  constructor() {
    super();
    this.state = { selectedTab: 0 };
  }

  /*********************************** LIFECYCLE ***********************************/
  async componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /*********************************** HANDLERS ***********************************/

  handleRefresh = () => {
    this.setState({ key: Math.random() });
  };

  getTabs() {
    const tabsContent = [
      {
        title: "Results",
        content: <PicaCSVzTab1 />,
      },
    ];
    return tabsContent.map((tab, index) => ({
      title: tab.title,
      getContent: () => tab.content,
      key: index,
    }));
  }
  /*********************************** MODAL DATA ***********************************/
  render() {
    return (
      <Fragment key={this.state.key}>
        <PageTitle
          heading={`PICA NGPON2 C&S Verizon Dashboard`}
          subheading={`Data from PICA NGPON2 C&S.`}
          icon="lnr-chart-bars"
          color="warning opacity-6"
          textColor="white"
          onRefresh={this.handleRefresh}
        />

        <Tabs
          tabsWrapperClass="body-tabs body-tabs-layout"
          transform={false}
          showInkBar={true}
          selectedTabKey={this.state.selectedTab}
          onChange={(tabIndex) => {
            this.setState({ selectedTab: tabIndex });
          }}
          items={this.getTabs()}
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Clients/PicaC&SVz/PicaC&SVzDashboard.jsx